import { render, staticRenderFns } from "./CollectionIssueEditDialog.vue?vue&type=template&id=d23699f2&scoped=true&"
import script from "./CollectionIssueEditDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectionIssueEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionIssueEditDialog.vue?vue&type=style&index=0&id=d23699f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23699f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VProgressLinear,VRow})
